import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M19.878 5.183H8.122a2.94 2.94 0 0 0-2.939 2.94v11.755a2.94 2.94 0 0 0 2.94 2.939h11.755a2.94 2.94 0 0 0 2.939-2.94V8.123a2.94 2.94 0 0 0-2.94-2.939m1.47 14.695a1.47 1.47 0 0 1-1.47 1.47H8.122a1.47 1.47 0 0 1-1.47-1.47V8.122a1.47 1.47 0 0 1 1.47-1.47h11.756a1.47 1.47 0 0 1 1.47 1.47z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M14 9.592a4.407 4.407 0 1 0 0 8.815 4.407 4.407 0 0 0 0-8.815m0 7.347a2.939 2.939 0 1 1 0-5.878 2.939 2.939 0 0 1 0 5.878M19.878 9.224a1.102 1.102 0 1 1-2.204 0 1.102 1.102 0 0 1 2.204 0"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "instagram"}) } }